import axios from "axios"

export default {
  async get() {
    // Add cache-busting parameter to ensure we always get the latest version
    let response = await axios.get(`/version.txt?t=${Date.now()}`)
    return response.data.trim()
  }
}
